module.exports = __webpack_public_path__ + "img/biznow-logo.cb635057.svg";